import { BodyFieldsPropperties } from "../../../constants"
import { TgMailing } from "../../../interfaces/mailing"
import { CSVRow } from "./csvForm"

/**
 * Строит `body` одного сообщения из строки CSV согласно сопоставлению
 * колонок (`collation`) и описанию полей метода (`BodyFieldsPropperties`).
 *
 * Логика повторяет формирование тела при сабмите формы: скрытые поля
 * подставляются из `default`, остальные берутся из соответствующей колонки
 * CSV и при наличии прогоняются через `parseValue`. Поле `token` исключается —
 * оно не является частью тела сообщения.
 */
export const buildRowBody = <M extends TgMailing.AvailableMethods>(
  method: M,
  row: CSVRow,
  collation: Record<string, string> | undefined,
): TgMailing.ApiMethodBody[M] => {
  const params = BodyFieldsPropperties[method] as Record<string, any>

  return (Object.entries(params) as [string, any][])
    .filter(([field]) => field !== "token")
    .reduce(
      (prev, [field, parameters]) => {
        const colName = collation?.[field]
        const value = colName ? row[colName] : undefined

        if (!parameters.hidden && (value === null || value === undefined)) {
          return prev
        }

        const newField = parameters.hidden
          ? parameters.default
          : typeof parameters.parseValue === "function"
            ? parameters.parseValue(value)
            : value

        return { ...prev, [field]: newField }
      },
      {} as TgMailing.ApiMethodBody[M],
    )
}
